import axios from 'axios';
switch (location.hostname) {
    //正式服
    case 'itrust.cn' : case 'www.itrust.cn' :
        axios.defaults.baseURL = 'https://api.knowsafe.com/knowsafe';
        break;
    //测试服
    default :
        axios.defaults.baseURL = 'http://192.168.0.107:8086/knowsafe';
        // axios.defaults.baseURL = 'https://api.knowsafe.com/knowsafe';
        break
}
// 添加请求拦截器
axios.interceptors.request.use(function (config) {
    config.data=JSON.stringify({param:config.data});
    // 在发送请求之前做些什么
    return config;
}, function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
});
// 添加响应拦截器
axios.interceptors.response.use(function (response) {
    // 对响应数据做点什么
    return response.data.response;
}, function (error) {
    // 对响应错误做点什么
    return Promise.reject(error);
});
/**
 * 接口API
 */
export default {
    //获取证书查询列表
    getitrustcertlist:function (params) {
        return axios.post(`/help/getitrustcertlist`,params)
    }
}


// WEBPACK FOOTER //
// ./src/assets/js/http.js